module.exports = __webpack_public_path__ + "assets/img/icon41.d5485597.png";